import React from 'react';
import PropTypes from 'prop-types';
import studentlogo from '../data/studentlogo.png';

const StudentComponent = ({ eleve }) => {
  return (
    <div
      className="flex items-center gap-4 p-4 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out border border-gray-100"
      role="article"
      aria-label={`Student profile for ${eleve.eleve}`}
    >
      {/* Student Logo */}
      <div className="flex-shrink-0 w-16 h-16 rounded-full overflow-hidden bg-gray-100">
        <img
          src={studentlogo}
          alt={`${eleve.eleve}'s profile logo`}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Student Details */}
      <div className="flex-1 flex flex-col gap-2">
        {/* Student Name */}
        <h1 className="text-xl font-semibold text-gray-800 capitalize">
          {eleve.eleve}
        </h1>

        {/* Class Information */}
        <div className="flex items-center justify-between text-sm text-gray-600">
          <span className="font-medium">Classe</span>
          <span className="font-bold text-gray-900">{eleve.classe.libelle}</span>
          <span className="text-gray-500">القسم</span>
        </div>

        {/* Matricule Information */}
        <div className="flex items-center justify-between text-sm text-gray-600">
          <span className="font-medium">Matricule</span>
          <span className="font-bold text-gray-900">{eleve.matricule}</span>
          <span className="text-gray-500">رقم التسجيل</span>
        </div>
      </div>
    </div>
  );
};

// PropTypes for type checking
StudentComponent.propTypes = {
  eleve: PropTypes.shape({
    eleve: PropTypes.string.isRequired,
    classe: PropTypes.shape({
      libelle: PropTypes.string.isRequired,
    }).isRequired,
    matricule: PropTypes.string.isRequired,
  }).isRequired,
};

// Default props (optional, in case you want to provide fallback values)
StudentComponent.defaultProps = {
  eleve: {
    eleve: 'Unknown Student',
    classe: { libelle: 'N/A' },
    matricule: 'N/A',
  },
};

export default StudentComponent;